import React from 'react';
import PropTypes from 'prop-types';
import Image from '@namia/image';
import Spacer from './Spacer';

const PostCard = ({
  post: {
    image: {
      src,
      srcset,
      placeholder,
      placeholderBase64,
      base64,
      width,
      height,
      alt,
    },
    title,
    excerpt,
    link,
    categories,
  },
  cardstyle,
}) => (
  <a href={link} className="postcard__link">
    <div className={`postcard postcard--${cardstyle}`} key={title}>
      <Image
        alt={alt}
        base64={base64}
        onError={() => {}}
        placeholder={placeholder}
        onLoad={() => {}}
        placeholderBase64={placeholderBase64}
        ratio={`${width}/${height}`}
        src={src}
        srcset={srcset}
      />
      <div className={`postcard__content postcard__content--${cardstyle}`}>
        <Spacer size="sm" />
        <p className="postcard__category">
          {categories.map((category) => category.name).join(', ')}
        </p>
        <Spacer size="sm" />
        <h3 className="postcard__title">{title}</h3>
        <Spacer size="sm" />
        <p className="postcard__excerpt">{excerpt}</p>
        <Spacer size="md" />
      </div>
    </div>
  </a>
);

PostCard.defaultProps = {
  cardstyle: 'primary',
};

PostCard.propTypes = {
  post: PropTypes.shape({
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      srcset: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired,
      placeholderBase64: PropTypes.string.isRequired,
      base64: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      alt: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  cardstyle: PropTypes.string,
};

export default PostCard;
